import React from 'react';
import Signin from './components/Signin';
import Account from './components/Account';
import { Route, Routes } from 'react-router-dom';
import { AuthContextProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PoomDataDetail from './components/datatable/PoomDataDetail';
import PoomDataChatroom from './components/datatable/PoomDataChatroom';
import PoomUsersTable from './components/userstable/PoomUsersTable';
import PoomReportsTable from './components/reportstable/PoomReportsTable';
import PoomReportsDetail from './components/reportstable/PoomReportsDetail';
import Navbar from './Navbar';

function App() {
  return (
    <div>
      <AuthContextProvider>
        <Routes>
          <Route path="/" element={<Signin />} />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Navbar />
                <Account />
              </ProtectedRoute>
            }
          />
          <Route
            path='/users'
            element={
              <ProtectedRoute>
                <Navbar />
                <PoomUsersTable />
              </ProtectedRoute>
            }
          />
          <Route
            path='/reports'
            element={
              <ProtectedRoute>
                <Navbar />
                <PoomReportsTable />
              </ProtectedRoute>
            }
          />
          <Route
            path='/reports/:id'
            element={
              <>
                <Navbar />
                <PoomReportsDetail />
              </>
            }
          />
          <Route
            path='/detail/:id'
            element={
              <>
                <Navbar />
                <PoomDataDetail />
              </>
            } />
          <Route
            path='/chatroom/:id'
            element={
              <>
                <Navbar />
                <PoomDataChatroom />
              </>
            } />
        </Routes>
      </AuthContextProvider>
    </div>
  );
}

export default App;
